import { Fragment } from 'react';
import Image from 'next/image';
import Header from '../components/Header';
import Footer from '../components/Footer';
import styles from '../styles/modules/500/500.module.scss';

const Page500 = () => {
  return (
    <Fragment>
      <Header />
      <main>
        <section className="block">
          <div className={['fixed', styles.content].filter(Boolean).join(' ')}>
            <h1 className={styles.contentTitle}>Ой... Что-то пошло не так!</h1>
            <div className={styles.contentDescription}>
              Мы уже знаем о проблеме и наши хомячки успешно раскручивают колесо по новой, нужно
              немного подождать!
            </div>
            <div className={styles.contentImage}>
              <Image src="/images/wondering-man.svg" fill alt="" style={{ objectFit: 'cover' }} />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </Fragment>
  );
};

export default Page500;
